var theme={};
theme.Palette = (function () {
  var selectors = {
      palette: ".palette",
      canvas: "[data-canvas]",
      imgPalette: "[data-img-palette]",
      colorChoice: ".color-list .color-choice",
      emptyPlt: ".color-list .empty-plt",
      ttl:".sm-ttl",
      colorChoicePos: ".color-list .color-pos .position",
       //tube
       pageType:"#htxSMPageType"
  };
  var color_setting = {};
  var selectedChoiceIndex = 0;
  function Palette(container,themProduct) {
    this.$container = $(container);
    this.$canvas = $(selectors.canvas, this.$container);
    this.canvasObj = this.$canvas[0];
    this.$imgPalette = $(selectors.imgPalette, this.$container);
    this.imgPaletteObj = this.$imgPalette[0];
    this.$emptyPlt = $(selectors.emptyPlt, this.$container);
    this.$colorChoice = $(selectors.colorChoice, this.$container);
    this.$colorChoicePos = $(selectors.colorChoicePos, this.$container);
    this.$ttl=$(selectors.ttl, this.$container);
    this.selectedColorList=[];
    this.themeProduct=themProduct;
    this.loading=false;
    //tube
    this.pageType=$(selectors.pageType).val();
    if(!this.pageType || this.pageType=="")this.pageType="palette";

    this.$btnAddCart=$(".btn-add-cart",this.$container);
    this.$loader=$("[data-loader]",this.$container);
    this.$errorMessageWrapper=$(".product-form__error-message-wrapper", this.$container);
    this.$quantityInput=$(".product-form__input--quantity",this.$container);
    this.$productForm=$("[data-sm-product-form]",this.$container);
    this.ajaxEnabled=true;

    this.$quantityInput.on("change",function(){
      //var price= parseFloat($(".sm-ttl").find(".regular-price .money").text().replace(/[^0-9.]/gi,""));
      var price=parseInt($(".sm-ttl").find(".product__price [tname=price]").val());
      var qty=parseInt($("[data-sm-quantity-input]").val());
      //var ttl=(price*qty).toFixed(2);
      //$(".total-money").find("span").text(ttl);
      $(".total-money").html(Shopify.formatMoney(price*qty, window.money_format));
    });
    if(this.$canvas.length>0){
      this._initPalette();
    }
    else{
      this._initTube();
    }
    if($(".cart-list").length>0 || $("#dropdown-cart").length>0){
      this._initCartPalatte();
    }
    $(".color-choice").find("ul li").first().addClass("sm-selected");
  }
  Palette.prototype = $.extend({}, Palette.prototype, {
      _exist:function(){
        var ret=false;
        if(this.$container.length>0) ret=true;
        else ret=false;
        return ret;
      },
      _initPalette: function () {
        var canvasObj = $(this.canvasObj);
        var ctx = this.canvasObj.getContext("2d");
        this.imgPaletteObj.onload = function () {
           this._imgChanged();
        }.bind(this);
        this.colorChoicePosTop = this.$colorChoicePos.offset().top;
        this._getSizeObject();
        this._initChoicePlt();
        this._initChoicePos();
        this._initChoiceColor();
        this._nextColorChoiceAutoClick();
        //this._bindScrollEvent();
        this._autoRefreshPalette();
        this._initColorTab();
        this._initClearSelected();
        this._initBtnAddToCart();
      },
      _getSelectedSku: function () {
          var ret = "",err="";
          this.$colorChoicePos.find("label").each(function (idx,e) {
              if ($(e).text() == "code") {
                err = "You have a choice of colors";
                return false;
              }
              else {
                if (ret != "") ret += ",";
                ret += $(e).text();
              }
          });
          $(".submit",this.$container).find("[data-properties-colors]").val(ret);
          return [ret, err];
      },
      _getSelectedSkuList: function () {
        var err="";
        var ret=[],idx=0;
        this.$colorChoicePos.find("label").each(function (idx,e) {
            if ($(e).text() != "code") {
              ret[idx]={};
              ret[idx].idx = $(e).parent().find("span").text();
              ret[idx].color = $(e).text();
              idx++;
            }
        });
        return ret;
      },
      _autoRefreshPalette: function () {
          var wid = window.setTimeout(function () {
              this._imgChanged();
              window.clearTimeout(wid);
          }.bind(this), 500);
      },
      _imgChanged: function () {
        this.$canvas = $(selectors.canvas, this.$container);
        this.canvasObj = this.$canvas[0];
        this.$imgPalette = $(selectors.imgPalette, this.$container);
        this.imgPaletteObj = this.$imgPalette[0];

        var imgObj = $(this.imgPaletteObj)
        var w = imgObj.width();
        var h = imgObj.height();
        if (w == 0) {
            this._autoRefreshPalette();
            return;
        }
        this.canvasObj.height = h;
        this.canvasObj.width = w;
        var wx = $(window).width() - 20;
        if (wx <= 980) {
            h = wx / w * h;
            w = wx;
        }
        else{
          wx=$(".palette",this.$container).width();
          h = wx / w * h;
          w = wx;
        }
        this.$canvas.width(w);
        this.$canvas.height(h);
        ctx = this.canvasObj.getContext("2d");
        ctx.scale(1, 1);
        //this.imgPaletteObj.crossOrigin= 'anonymous';
        ctx.drawImage(this.imgPaletteObj, 0, 0);
        window.setTimeout(function(){this._autoSelectColorList();}.bind(this),500);
      },
      _bindScrollEvent: function () {
        $(window).scroll(function () {
          var wx = $(window).width() - 20;
          if (wx >= 1000) {
            return;
          }
          var t = $(window).scrollTop();
          if (t > this.colorChoicePosTop +10) {
            var tab=this.$colorChoice.find(".sm-color-tab");
            tab.removeClass("fix-top").addClass("fix-top");
            this.$colorChoicePos.removeClass("fix-top").addClass("fix-top").css("z-index",9);
            this.$colorChoice.css("padding-top", (this.$colorChoicePos.height()+15)+"px");
            tab.css({"padding-top":this.$colorChoicePos.height()+20+"px","z-index":1});
          } else {
            var tab=this.$colorChoice.find(".sm-color-tab");
            tab.removeClass("fix-top");
            this.$colorChoice.find(".sm-color-tab").removeClass("fix-top");
            this.$colorChoicePos.removeClass("fix-top").css("padding-top", "");
            this.$colorChoice.css("padding-top", "");
            tab.css({"padding-top":"","z-index":0});
          }
        }.bind(this));
      },
      _initClearSelected:function(){
        $(".clear-selected",this.$container).on("click",function(){
          this._clearSelectColor();
        }.bind(this));
      },
      _initChoicePlt: function () {
        this.$emptyPlt.find("img").on("click", function (event) {
            if(this.loading)return;

            event.stopPropagation();
            var obj = $(event.target);
            var li = obj.closest("li");
            li.removeClass("sm-selected").addClass("sm-selected").siblings().removeClass("sm-selected");
            this._clearCanvas();
            this.$imgPalette.removeAttr("src");
            this.$imgPalette.attr("src", obj.data("src-original"));
            //this._initChoicePos();
            this._nextColorChoiceAutoClick();
            this._autoRefreshPalette();
            $(".sm-price-hide",this.$ttl).html($(".sm-price-hide",li).html());
            var id=li.find("[tname='id']").val();
          
            $("#ProductSelect-product-template-default").val(id);
            this._bindChildPlt(event);
        }.bind(this));
        this.$emptyPlt.find("img").first().click();
      },
      _bindChildPlt:function(event){
        var fn=function(event){
          //event.stopPropagation();
          //selected class
          var objVariant=$("#ProductSelect-product-template-default");
          objVariant.off("change").off("click").closest("form").off("change").off("change");
          var li = $(event.target).closest("li");
          li.removeClass("sm-selected").addClass("sm-selected").siblings().removeClass("sm-selected");
          objVariant.val(li.find("[tname='id']").val());
          //get elements
          var txt=li.find("label").text().trim();
          var id=li.find("[tname='id']").val();
          //get parent node text
          var atText=objVariant.find("option[value='"+id+"']").text();
          var atIdx=atText.toLowerCase().indexOf(txt.toLowerCase()+" / ");
          if(atIdx<0){atIdx=atText.toLowerCase().indexOf(" / "+txt);}
          var prefix=atIdx>0?atText.substring(0,atIdx,(txt+" / ").length):"";
          //get child html
          var html="";
          var ul=$(li).closest("ul");
          objVariant.find("option").each(function(idx,el){
            var stxt=$(el).text();
            var sid=$(el).attr("value");
            if(stxt.toLowerCase().indexOf((prefix+txt+" / ").toLowerCase())>=0){
              html+="";
              stxt=stxt.replace(prefix+txt+" / ","");
              var splitPos=stxt.indexOf("/");
              var cls="";
              if(splitPos>0)stxt=stxt.substring(0,splitPos).trim();
              else stxt=stxt.trim();
              if(stxt.toUpperCase().indexOf("- SOLD OUT")>0){
                cls="class='disabled'";
              }
              html+="<li class=\"li-text\"><label "+cls+">"+stxt.toUpperCase()+"</label><input type=\"hidden\" tname=\"id\" value=\""+sid+"\" /></li>";
            }
          });
          objVariant.val(id);
          $("#ProductSelect-product-template-default").val(id);
          //auto trigger click event of child node 
          var nextObj=ul.nextAll("ul").first();
          nextObj.html(html);
          nextObj.find("li").off("click").on("click",fn);
          nextObj.find("li").first().click();
          if(nextObj.length==0){
            $(".sm-product__price",this.$container).html($("#divSMAllVariantPrice").find("input[value='"+id+"']").closest("div").html());
            $("#Quantity-product-template-default").change();
             //show upload part
            $("#divUploadkit").hide();
            if(txt.toUpperCase()=="SINGLE COLOR" || txt.toUpperCase()=="MULTI COLOR" || txt.toUpperCase()=="DOUBLE COLOR"){
              $("#divUploadkit").show();
              var tmidx=$("#divUploadkit").attr("tmid");
              if(tmidx){
                window.clearTimeout(tmidx);
              }
              tmidx=window.setTimeout(this._fixUpload,300);
              $("#divUploadkit").attr("tmid",tmidx);
            }
          }
        }.bind(this);
        fn(event);
      },
      _fixUpload:function(){
        var tmid=0,countStep=0
        var fnx=function(){
          $(".uploadkit-uploader").show(); 
          window.clearTimeout(tmid);
          if(countStep<10){tmid=window.setTimeout(fnx,500);}
          countStep++;
        }
        tmid=window.setTimeout(fnx,500);
      },
      _initChoicePos: function () {
        var r = this.color_setting.layout.r;
        var c = this.color_setting.layout.c;
        var html = "";
        var idx = 1;
        for (var i = 0; i < r; i++) {
          html += "<ul>";
          if(c.indexOf(",")>0){
            var arrCol=c.split(',');
            var endIdx=0;
            if(arrCol.length>i)endIdx=arrCol[i];
            for (var j = 0; j < endIdx; j++) {
                if($("#chkSmPltShowCCode").prop("checked")){
                  html += "<li><span data-choice-color>" + idx + "</span><label>code</label></li>";
                }
                else{
                  html += "<li><span data-choice-color>" + idx + "</span><label class='myhide'>code</label></li>";
                }

                idx++;
            }
          }
          else{
            for (var j = 0; j < c; j++) {
                if($("#chkSmPltShowCCode").prop("checked")){
                  html += "<li><span data-choice-color>" + idx + "</span><label>code</label></li>";
                }
                else{
                  html += "<li><span data-choice-color>" + idx + "</span><label class='myhide'>code</label></li>";
                }

                idx++;
            }
          }
          html += "</ul>";
        }
        this.$colorChoicePos.html(html);
        this.$colorChoicePos.find("span").off("click").on("click", function (event) {

          event.stopPropagation()
          var obj = $(event.target);
          var li = obj.closest("div").find("li").removeClass("sm-selected");
          obj.closest("li").removeClass("sm-selected").addClass("sm-selected");
          this.selectedChoiceIndex = obj.text().trim();
          return;
        }.bind(this));
        //
        $("#chkSmPltShowCCode").off("click").on("click",function(event){
          event.stopPropagation();
          this.$emptyPlt.find("li.sm-selected img").click();
        }.bind(this));
        
        this.$colorChoicePos.find("span").first().click();
        this._ShowPreviewPic();
      },
      
    _initChoiceColor: function () {
          this.$colorChoice.find("img").on("click", function (event) {
            if(this.loading)return;
            event.stopPropagation();
            if (this.selectedChoiceIndex <= 0) return;
            var obj = $(event.target);
            var li = obj.closest("li");
            li.removeClass("sm-selected").addClass("sm-selected").siblings().removeClass("sm-selected");
            this._fillColor(obj);
            this._getSelectedSku();
            return;
          }.bind(this));
      },
    _ShowPreviewPic:function(){
        if($(".sm-cpalette").attr("data-palette-color").indexOf("lash")<0)return;
        var html="<div id='__sm_diy_preview_img' style='position:fixed;bottom:0px;left:50%;z-index:999;border:1px solid #ccc;'><div style='position:absolute;top:0px;right:0px;z-index:999;cursor:pointer;display: block;width: 100%;background-color: #f9f9f9;padding: 5px;'><span style='color: black;text-align: left;font-weight: bold;'>Eyelashes Preview</span><span id='__sm_diy_preview_img_close' style='float:right;color:red;cursor:pointer;'>X</span></div><img style='width:200px;' src='' /></div>";
      $(".sm-cpalette .color-pos .position li span").click(function(evt){
            var e=$(evt.target || evt.srcElement) ;
            var img=e.css("background-image").replace('url("',"").replace('")');
            if(img=="none" || img=="")return;
            
            var obj=$("#__sm_diy_preview_img");
            if(obj.length==0){
              $(document.body).append($(html));
              obj=$("#__sm_diy_preview_img");
              $("#__sm_diy_preview_img_close").click(function(){
                $("#__sm_diy_preview_img").hide();
              });
            }
            obj.find("img").attr("src",img);
             var w=$(document.body).width()/2-100;
            $("#__sm_diy_preview_img").css("left",w+"px").show();
        });
      
        $(".sm-cpalette .color-choice ul li img").click(function(evt){
          var e=$(evt.target || evt.srcElement) ;
          var img=e.attr("src");
          if(img=="none" || img=="")return;
          var obj=$("#__sm_diy_preview_img");
          if(obj.length==0){
            $(document.body).append($(html));
            obj=$("#__sm_diy_preview_img");
            $("#__sm_diy_preview_img_close").click(function(){
              $("#__sm_diy_preview_img").hide();
            });
          }
          obj.find("img").attr("src",img);
           var w=$(document.body).width()/2-100;
            $("#__sm_diy_preview_img").css("left",w+"px").show();
        });
      
        
      },
      _initColorTab:function(){
        var tabs=this.$colorChoice.find(".sm-color-tab span");
        tabs.on("click",function(event){
          event.stopPropagation();
          var obj = $(event.target);
          var uls=this.$colorChoice.find("ul");
          obj.siblings().removeClass("slc");
          obj.removeClass("slc").addClass("slc");
          uls.hide();
          var ridx=obj.index();
          uls.eq(ridx).show();
          // var wx = $(window).width() - 20;
          // if (wx < 980) {
          //   var scrollTop=this.$colorChoice.find("h3").offset().top;
          //   scrollTop=scrollTop-(obj.height()+this.$colorChoicePos.height());
          //   $('html, body').animate({scrollTop: scrollTop}, 500);
          // }
        }.bind(this));
        tabs.first().click();
      },
      _clearCanvas: function () {
          var ctx = this.canvasObj.getContext("2d");
          var h = ctx.height;
          this.canvasObj.height = h;
          this.$colorChoicePos.find("span").removeAttr("data-set").removeAttr("style");
          this._initChoicePos();
          this._autoDisabledColorList();
      },
      _clearSelectColor:function(){
        this.selectedColorList=[];
        this.selectedChoiceIndex=-1;
        this.$emptyPlt.find(".sm-selected img").click();
      },
      _getSizeObject: function () {
          var ret = {};
          var size =this.$container.data("palette-set");// "layout=r3-c3;size=w76-h76;1=x28-y368;2=x125-y368;3=x220-y368;4=x28-y463;5= x125-y463; 6 = x220-y463;7 = x28-y560; 8 = x125-y560; 9 = x222-y560;";
          var arr = size.split(";");
          var d = null;
          ret.layout = {};
          ret.size = {};
          ret.list = [];
          var idx = 0, name = "", value = "";
          var exp = null;

          for (var i = 0; i < arr.length; i++) {
              d = arr[i];
              if (d.trim() == "") continue;
              idx = 0, name = "", value = "";
              exp = d.split("=");
              if (exp[0].trim().toLowerCase() == "layout") {
                  var expEx = exp[1].split("-");
                  if (expEx.length < 2) alert("Wrong parameter！");
                  ret.layout.r = expEx[0].replace("r", "").trim();
                  ret.layout.c = expEx[1].replace("c", "").trim();
              }
              else if (exp[0].trim().toLowerCase() == "size") {
                  var expEx = exp[1].split("-");
                  if (expEx.length < 2) alert("Wrong parameter！");
                  ret.size.w = parseInt(expEx[0].replace("w", "").trim(),10);
                  ret.size.h = parseInt(expEx[1].replace("h", "").trim(),10);
              }
              else if (exp[0].trim().toLowerCase() != "size") {
                  idx = exp[0].trim();
                  ret.list[idx] = {};
                  var expEx = exp[1].split("-");
                  if (expEx.length < 2) alert("Wrong parameter！");
                  name = expEx[0];
                  value = expEx[1];
                  ret.list[idx].x =parseInt(expEx[0].replace("x", "").trim(),10);
                  ret.list[idx].y =parseInt(expEx[1].replace("y", "").trim(),10);
              }
          }
          this.color_setting = ret;
          return ret;
      },
      _fillColor: function (obj) {
          var idx = this.selectedChoiceIndex;
          if (idx <= 0) return;
          //var objImg=$("<img src='"+obj.attr("src")+"&v2="+g_random()+"' />");
          var img = $(obj)[0];
          var w = this.color_setting.size.w;
          var h = this.color_setting.size.h;
          var x = this.color_setting.list[idx].x;
          var y = this.color_setting.list[idx].y;
          var ctx = this.canvasObj.getContext("2d");
          img.crossOrigin= 'anonymous';
          ctx.drawImage(img, x, y, w, h);
         
          var ckey=obj.next().text();
          if($("#chkSmPltShowCCode").prop("checked")){
            if(w>100){ctx.font="normal normal bold 25px arial";}
            else ctx.font="normal normal bold 14px arial";
            var txtw=ctx.measureText(ckey).width;
            var txth=10;
            var txtx=x+(w/2-txtw/2);
            var txty=y+(h/2+txth/2);
            ctx.fillStyle="white";
            
            ctx.fillText(ckey,txtx,txty);

            ////ctx.strokeStyle='#111'
            //ctx.strokeText(ckey,txtx,txty);
          }
        
          var choicePos = this.$colorChoicePos.find("span:eq(" + (idx - 1) + ")");
          choicePos.css({"background-image": "url(" + obj.attr("src") +")",'background-repeat':'no-repeat','background-size':'50px 50px','background-position':'center center'});
          choicePos.attr("data-set", "1");
          choicePos.next().text(ckey);
          this._autoDisabledColorList();
          this._nextColorChoiceAutoClick();
          this.selectedColorList=this._getSelectedSkuList();
          // window.setTimeout(function(){
          //       var imgData= this.canvasObj.toDataURL("image/jpeg", 1);
          //       imgData=this._changeFileToBaseURL(imgData,100);
                
          // }.bind(this),100);
      },
      _autoDisabledColorList: function () {
          this.$colorChoice.find("label").each(function (idx, e) {
              $(e).removeClass("disabled");
              this.$colorChoicePos.find("label").each(function (ix, el) {
                  if ($(el).text().trim() == $(e).text().trim()) {
                      $(e).addClass("disabled");
                      return false;
                  }
              }.bind(this));
          }.bind(this));
      },
      _autoSelectColorList: function () {
        this._initChoicePos();
        var slc=this.selectedColorList;
        if(!slc || slc.length<=0)return;

        for(var i=0;i<slc.length;i++) {
          this.selectedChoiceIndex=parseInt(slc[i].idx,10);

          this.$colorChoice.find("label").each(function (ix, el) {
            if ($(el).text().trim() == slc[i].color.trim()) {
              $(el).parent().find("img").click();
                return false;
            }
          }.bind(this));
        };
      },
      _nextColorChoiceAutoClick: function () {
          this.selectedChoiceIndex = -1;
          this.$colorChoicePos.find("li").removeClass("sm-selected");
          this.$colorChoicePos.find("span:not([data-set])").first().click();this.selectedChoiceIndex = -1;
          this.$colorChoicePos.find("li").removeClass("sm-selected");
          this.$colorChoicePos.find("span:not([data-set])").first().click();
      },
      _changeFileToBaseURL:function(base64,pw){
        if(!base64) return "";
        var image =$("#img1")[0];
        image.src = base64;
        image.width=this.canvasObj.width;
        image.height=this.canvasObj.height;
        
        var scale = this.canvasObj.width / this.canvasObj.height;

        var canvas = $("#canvas1")[0];
        var ctx = canvas.getContext("2d");
        canvas.width =  pw;
        canvas.height = parseInt(pw / scale);
       
        //ctx.drawImage($("#img1")[0], 0, 0, canvas.width, canvas.height);
        window.setTimeout(function(){
          $("#canvas1")[0].getContext("2d").drawImage($("#img1")[0],0, 0,100,100);
          var sdata = $("#canvas1")[0].toDataURL("image/jpeg",1);
          var paletteContainer=$("[data-properties-paletteimgbin-list]",this.$container);
          paletteContainer.html("");

          var len=sdata.length,sublen=9000;
          var sx="";
          var isize=parseInt(len/sublen);
          var modNum=len%sublen;
          if(modNum>0){isize++;}
          
          for(var i=0;i<isize;i++){
            sx=sdata.slice(0,sublen);
            sdata=sdata.slice(sublen);
            paletteContainer.append($('<input type="hidden" name="properties[PaletteImageBin'+i+']" value="'+sx+'" data-properties-paletteimgbin />'))
          }
        },100);

      },
    _uploadFile:function(mfn){
        if(!$("#chkSmPltShowCCode").prop("checked")){
          $("[data-properties-colors]",this.$container).val("");
          $("#chkSmPltShowCCode").click();
         }
          var selfFn=function(){
            if($("[data-properties-colors]",this.$container).val()==""){
              window.setTimeout(selfFn,300);
            }
            else{
              //if(mfn)mfn("");
              this._uploadFileEx(mfn);
            }
          }.bind(this);

          selfFn();
        
      },
      _uploadFileEx:function(fn){
        if(this.loading)return;
        this.loading=true;
        
        this.canvasObj.toBlob(function (blobObj) {
            var err="";
            var file = new window.File([blobObj], parseInt(Math.random()*1000000000)+".png", { type: "image/png" });
            var formData = new FormData();
            formData.append('file', file);
            formData.append('billtype', "shopdomanibeauty"); 
            formData.append('sectype', "CustomPalette");
          
          
            $.ajax({
                url: "https://www.msoffermakeup.com/Hnd/Upload.ashx",
                type: "Post",
                cache: false, 
                data: formData,
                contentType: false,
                processData: false,
                success: function (data) {
                  err="";
                  if(data.Success){
                    if(data.Path.length>0){
                      $(".submit",this.$container).find("[data-properties-custom-palette-url]").val("https://www.msoffermakeup.com"+data.Path[0].replace("s100x100_",""));
                    }
                    else{
                      $(".submit",this.$container).find("[data-properties-custom-palette-url]").val("");
                      err="Sorry,error ocurred while uploading image of palette,pls try again!";
                    }
                  }
                  else{
                   err="Sorry,error ocurred while uploading image of palette ,pls try again!";
                  }
                  if(fn)fn(err);
                }.bind(this),
                error: function (data) {
                  err="Sorry,error ocurred while uploading image of palette ,pls try again!";
                  if(fn)fn(err);
                }
            });
        })
      },
      _handleButtonLoadingState:function(isLoading){
        if(isLoading){
          this.$loader.show();
          this.$loader.find(".icon").attr("class","icon icon-spinner");
          this.$btnAddCart.attr("aria-disabled","true");
        }
        else{
          this.$loader.hide();
          this.$loader.find(".icon").attr("class","icon");
          this.$btnAddCart.removeAttr("aria-disabled");
        }
      },
      _showErrorMessage: function(errorMessage) {
        $(".product-form__error-message", this.$container).html(errorMessage);
        // if (this.$quantityInput.length !== 0) {
        //   this.$quantityInput.addClass(this.classes.inputError);
        // }
        this.$errorMessageWrapper.removeClass("sm-hide")
      },
      _hideErrorMessage: function() {
        this.$errorMessageWrapper.removeClass("sm-hide").addClass("sm-hide");
        // if (this.$quantityInput.length !== 0) {
        //   this.$quantityInput.removeClass(this.classes.inputError);
        // }
      },
      _initBtnAddToCart:function(){
        this.$btnAddCart.on("click",function(evt){
          if(this.loading)return;
          var obj = $(evt.target);
          var disabled=$(obj).attr("aria-disabled");
          if(disabled)return;
          if (!this.ajaxEnabled) return;

          evt.preventDefault();

          this.$previouslyFocusedElement = $(':focus');
          var isInvalidQuantity = this.$quantityInput.val() <= 0;
          if (isInvalidQuantity) {
            this._showErrorMessage("Quantity must be 1 or more");
            return;
          }
          //palette color select
          if($("[data-properties-colors]",this.$container).length>0){
            var slcColors=$("[data-properties-colors]",this.$container).val().trim();
            if(slcColors=="" || slcColors.indexOf("code")>=0){
              this._showErrorMessage("Palette exist blank color,pls fully select.");
              return;
            }
          }

          if (!isInvalidQuantity && this.ajaxEnabled) {
            // disable the addToCart and dynamic checkout button while
            // request/cart popup is loading and handle loading state
            this._handleButtonLoadingState(true);
            var $data = $("#add-to-cart-form", this.$container);
            $(".submit",this.$container).find("[data-properties-custom-palette-url]").val("");
            if(this._exist()){
              this._uploadFile(function(err){
                if(err!=""){
                  this._showErrorMessage(err);
                }
                else{
                  this._addItemToCart($data);
                }
              }.bind(this));
            }
            else{ this._addItemToCart($data);}
            return;
          }
          return;
        }.bind(this));
      },
      _addItemToCart: function(data) {
      $.ajax({
        type: "post",
        url: "/cart/add.js",
        data: $(data).serialize(),
        dataType: "json",
        beforeSend: function() {},
        success: function(t) {
          this.loading=false;
          this._hideErrorMessage();
          this._handleButtonLoadingState(false);
          
          if(this.pageType=="palette"){
            window.location.href="/cart";
          }
          else{
            this._getSelectedTubeColorList(function(){
              // var slcColor=$("#divSMColorChoice").find("li.sm-selected").first().find("label").text();
              // var slcTube=$("#ProductSelect-product-template-default").find("option:selected").text().trim();
              // var h4=$("#divSMSelectedColorIn h4:contains("+slcTube+")");
              // $(window).scrollTop(h4.offset().top-50);
              // var lbl= h4.next("dl").find("label:contains("+slcColor+")").each(function(idx,el){
              //   if($(el).text()==slcColor){
              //       $(el).click();
              //   }
              // });
              this._setSelectedTubeStyle(true);
              this.$quantityInput.val("1");
            }.bind(this));
            // var slcColor=$("#divSMColorChoice").find("li.sm-selected").first().find("label").text();
            // var slcTube=this.$quantityInput.find("option:selected").text().trim();
            //this._showMsg("You have added the lip tube No. "+slcTube+" and with the color No. "+slcColor+", you can continue selecting other lip tube and colors.",5000);
            //$("[data-cart-toggle]:visible").click();
            // this.$quantityInput.val("1");
            // this.$quantityInput.change();
             var tmid=window.setTimeout(function(){
               $("[data-cart-toggle]:visible").click();
               window.clearTimeout(tmid);
             },1000);
          }
        }.bind(this),
        error: function(e, i) {
          this.loading=false;
          this.$previouslyFocusedElement.focus();
          var errorMessage = response.responseJSON
            ? response.responseJSON.description
            : "There was an error while updating your cart. Please try again.";
          this._showErrorMessage(errorMessage);
          this._handleButtonLoadingState(false);
        }.bind(this)
      });
    },
    _initCartPalatte:function(){
      function delayfn(){
        $(".cart-list").find("li").find(".properties label:contains(CustomPaletteUrl)").each(function(idx,e){
            
          var li =$(e).closest("li");
            var selfObj=$(e);
            var url=selfObj.next().attr("href");
          if(!url){
            var regexp = /((http|ftp|https|file):\/\/([\w\-]+\.)+[\w\-]+(\/[\w\u4e00-\u9fa5\-\.\/?\@\%\!\&=\+\~\:\#\;\,]*)?)/ig;
            url = selfObj.parent().text().match(regexp);
              var shtml="<a href='"+url+"' target='_blank'>Link</a>";
              selfObj.parent().html(selfObj.parent().html().replace(url,shtml));
          }
            if(url.indexOf("s100x100_")<0){
              var pos=url.lastIndexOf("/")+1;
              url.slice(0,pos)+"s100xs100_"+url.slice(pos);
            }
            li.find(".cart-thumb .product-img img").first().attr("src",url);
        });
        
        $("#dropdown-cart .mini-products-list").find(".properties label:contains(CustomPaletteUrl)").each(function(idx,e){
          var li =$(e).closest("li");
          var selfObj=$(e);
          var url=selfObj.next().attr("href");
          if(url.indexOf("s100x100_")<0){
            var pos=url.lastIndexOf("/")+1;
            url.slice(0,pos)+"s100xs100_"+url.slice(pos);
          }
          li.find(".product-image img").first().attr("src",url);
        });
    }
    delayfn();
    window.setTimeout(delayfn,1000);
    window.setTimeout(delayfn,2000);
    window.setTimeout(delayfn,5000);

    },
    _removeItem:function(line,t, r){
      var data=line!=null?"quantity=0&line=" + line:"quantity=0&id=" + t;
      $.ajax({
        type: "post",
        url: window.router +"/cart/change.js",
        data: data,
        dataType: "json",
        beforeSend: function() {},
        success: function(t) {
          "function" == typeof r ? r(t) : Shopify.onCartUpdate(t);
        }.bind(this),
        error: function(t, r) {
          Shopify.onError(t, r)
        }.bind(this)
      });
    },
    _initTube:function(){
      this._bindTubeEvent();
      //tube
      this._initChoiceColorTube();
      //tube
      this._initColorTabTube();
      //tube
      this._initBtnAddToCartTube();
      this._getSelectedTubeColorList(function(){
       this._setSelectedTubeStyle();
      }.bind(this));
    },
    _setSelectedTubeStyle:function(scrollSlc){
      var slcTube=$("#ProductSelect-product-template-default").find("option:selected").text().trim();
      var h4=$("#divSMSelectedColorIn h4:contains("+slcTube+")");
      $("#divSMSelectedColorIn").find("h4").css({"color":""});
      h4.css({"color":"#e95144"});
      if(scrollSlc){
        var slcColor=$("#divSMColorChoice").find("li.sm-selected").first().find("label").text();
        $(window).scrollTop(h4.offset().top-50);
        h4.next("dl").find("label:contains("+slcColor+")").each(function(idx,el){
          if($(el).text()==slcColor){
              $(el).click();
          }
        });
      }

    },
    _bindTubeEvent:function(){
      var fn=function(event){
        event.stopPropagation();
        //selected class
        var objVariant=$("#ProductSelect-product-template-default");
        
        var li = $(event.target).closest("li");
        li.removeClass("sm-selected").addClass("sm-selected").siblings().removeClass("sm-selected");
        objVariant.val(li.find("[tname='id']").val());
        //get elements
        var txt=li.find("label").text().trim();
        var id=li.find("[tname='id']").val();
        var img=li.find("img");
        //get parent node text
        var atText=objVariant.find("option[value='"+id+"']").text();
        var atIdx=atText.toLowerCase().indexOf(txt+" / ");
        if(atIdx<0){atIdx=atText.toLowerCase().indexOf(" / "+txt);}
        var prefix=atIdx>0?atText.substring(0,atIdx,(txt+" / ").length):"";
        //get child html
        var html="";
        var ul=$(li).closest("ul");
        objVariant.find("option").each(function(idx,el){
          var stxt=$(el).text();
          var sid=$(el).attr("value");
          if(stxt.toLowerCase().indexOf((prefix+txt+" / ").toLowerCase())>=0){
            html+="";
            stxt=stxt.replace(prefix+txt+" / ","");
            var splitPos=stxt.indexOf("/");
            var cls="";
            if(splitPos>0)stxt=stxt.substring(0,splitPos).trim();
            else stxt=stxt.trim();
            if(stxt.toUpperCase().indexOf("- SOLD OUT")>0){
              cls="class='disabled'";
            }
            html+="<li class=\"li-text\"><label "+cls+">"+stxt.toUpperCase()+"</label><input type=\"hidden\" tname=\"id\" value=\""+sid+"\" /></li>";
          }
        });
        //show upload part
        $("#divUploadkit").hide();
        if(txt.toUpperCase()=="SINGLE COLOR" || txt.toUpperCase()=="MULTI COLOR" || txt.toUpperCase()=="DOUBLE COLOR"){
          $("#divUploadkit").show();
        }
        objVariant.val(id);
        $("#ProductSelect-product-template-default").val(id);
        //auto trigger click event of child node 
        var nextObj=ul.nextAll("ul").first();
        nextObj.html(html);
        nextObj.find("li").off("click").on("click",fn);
        nextObj.find("li").first().click();
        if(nextObj.length==0){

          // var tmid=$("#divSMSelectedColorIn").attr("tmid");
          // if(tmid){window.clearTimeout(tmid);}
          // tmid=window.setTimeout(this._getSelectedTubeColorList.bind(this),350);
          // $("#divSMSelectedColorIn").attr("tmid",tmid);

          $(".sm-product__price",this.$container).html($("#divSMAllVariantPrice").find("input[value='"+id+"']").closest("div").html());
          $("#Quantity-product-template-default").change();
          
          var slcTube=$("#ProductSelect-product-template-default").find("option:selected").text().trim();
          $("#divSMSelectedColorIn").find("h4").css({"color":""});
          $("#divSMSelectedColorIn h4:contains("+slcTube+")").css({"color":"#e95144"});
        }
        //image show in left show area
        if(img.length>0){
          var origionUrl=img.attr("data-src-original");
          var smallUrl=img.attr("src");
          this._viewTubeImg(origionUrl,smallUrl);
        }

      }.bind(this);
      this.$emptyPlt.find("li").off("click").on("click",function (event) {
        fn(event);
      }.bind(this));
      this.$emptyPlt.find("li").first().click();
    },
    _viewTubeImg:function(origionUrl,smallUrl){
        var objNav = $("[data-media-id='000000']",this.$container);
        objNav.find("a").attr("data-image",origionUrl);
        objNav.find("a img").attr("data-src-original",origionUrl).attr("src",smallUrl);
        //show the image on left side
        var objShow=$("#product-featured-image-000000");
        objShow.attr("src",origionUrl).attr("data-src",origionUrl);
        var objShowA=objShow.closest("a");
        objShowA.attr("href",origionUrl);
        objShowA.find("[role='presentation']").attr("src",origionUrl);
        objNav.click();
    },
    _initChoiceColorTube: function () {
      this.$colorChoice.find("img").on("click", function (event) {
        event.stopPropagation();
        if (this.selectedChoiceIndex <= 0) return;
        var obj = $(event.target);
        var ul = obj.closest("ul");
        ul.closest(".color-choice").find("li").removeClass("sm-selected");
        var li = obj.closest("li");

        li.removeClass("sm-selected").addClass("sm-selected").siblings().removeClass("sm-selected");
        var slcColor=li.find("label").text();
       
        $("[data-properties-colors]",this.$container).val(slcColor);
        return;
      }.bind(this));
      this.$colorChoice.find("img").first().click();
    },
    _initColorTabTube:function(){
      var tabs=this.$colorChoice.find(".sm-color-tab span");
      tabs.on("click",function(event){
        event.stopPropagation();
        var obj = $(event.target);
        var uls=this.$colorChoice.find("ul");
        obj.siblings().removeClass("slc");
        obj.removeClass("slc").addClass("slc");
        uls.hide();
        var ridx=obj.index();
        uls.eq(ridx).show();
        
      }.bind(this));
      tabs.first().click();
    },
    _getSelectedTubeColorList: function(fn) {
      $("#divSMSelectedColor").hide();
      var objProd=$("#htxProductID");
      var pid=objProd.val();
      if(!pid){
        $("#divSMSelectedColorIn").html("");
        $("#divSMSelectedColor").hide();
        return;
      }
      
      $.getJSON('/cart.js').then(function (cart) {
          var d=0,color="",html="",url="";
          var arrv=[],objColors={},exists=false;
          $(".color-choice-tube ul li label",this.$container).removeClass("disabled");
          for(var i=0;i<cart.items.length;i++){
            d=cart.items[i];
            exists=false;
            if(d.product_id==pid && d.properties && d.properties.Colors){
              for(var j=0;j<arrv.length;j++){
                if(arrv[j]==d.variant_id){exists=true;break;}
              }
              if(!exists){
                arrv[arrv.length]=d.variant_id;
                objColors[d.variant_id]={};
                objColors[d.variant_id].title= d.variant_title;
                url=d.image;
                if(url!=""){
                  url=url.slice(0,url.lastIndexOf("."))+"_80x"+url.slice(url.lastIndexOf("."));
                }
                objColors[d.variant_id].html="<dd class='prod'><img dsrc=\""+d.image+"\" src=\""+url+"\"/><label>"+d.sku+"</label></dd>";
                objColors[d.variant_id].img=d.image;
                objColors[d.variant_id].smallImg=url;
              }

              color=d.properties.Colors;
              $(".color-choice-tube ul li ",this.$container).find("label:contains('"+color+"')").each(function(idx,el){
                if($(el).text()==color){
                  var url=$(el).closest("li").find("img").attr("src");
                  objColors[d.variant_id].html+="<dd data-idx='"+i+"' data-id='"+d.variant_id+"'><img src=\""+url+"\" /><label>"+color+"</label><span>"+d.quantity+"</span><a href='javascript:void(0)'>X</a></dd>";
                  $(el).removeClass("disabled").addClass("disabled");
                }
              });
            }
          }

          for(var i=0;i<arrv.length;i++){
            html+="<h4>Selected Colors For "+objColors[arrv[i]].title+"<a class='del' href='javascript:void(0)'>CLEAR ALL</a></h4>";
            html+="<dl>"+objColors[arrv[i]].html+"</dl>";
          }
          if(html!=""){
            $("#divSMSelectedColorIn").html(html);
            $("#divSMSelectedColor").show();
            $("#divSMSelectedColorIn").find("dd").off("click").on("click",function(evt){
              evt.preventDefault(),
              evt.stopPropagation();
              var dd =$(evt.target).closest("dd");
              dd.closest("dl").find("a").hide();
              dd.closest(".selected-list").find("dd").removeClass("slc");
              dd.addClass("slc");
              if(dd.hasClass("prod")){
                var img =dd.find("img");
                this._viewTubeImg(img.attr("dsrc"),img.attr("src"));
                $("#product-featured-image-000000").click();
              }
              else dd.find("a").show();
            }.bind(this));
           
            $("#divSMSelectedColorIn h4").find("a.del").off("click").on("click",function(evt){
              evt.preventDefault(),
              evt.stopPropagation();
              var h4=$(evt.target).closest("h4");
              var vid=h4.next("dl").find("dd[data-id]").first().attr("data-id");
              this._removeItem(null,vid,function(e){
                h4.next("dl").remove();
                h4.remove();
                g_sm_ella.doUpdateDropdownCart(e),
                g_sm_ella.checkBundleProducts();
                // this._getSelectedTubeColorList(function(){
                //   this._setSelectedTubeStyle(function(){
                //     this._setSelectedTubeStyle();
                //   }.bind(this));
                // }.bind(this));
              }.bind(this));
            }.bind(this));
           
            $("#divSMSelectedColorIn dl").find("a").off("click").on("click",function(evt){
              evt.preventDefault(),
              evt.stopPropagation();
              var a =$(evt.target);
              var dd=a.closest("dd");
              dd.closest("dl").find("a").removeClass("slca");
              a.addClass("slca");
              var line=parseInt(dd.attr("data-idx"),10)+1;
              var vid=dd.attr("data-id");

              this._removeItem(line,vid,function(e){
                // $("#cart-item-" + vid).remove(),
                // $("#sidebar-cart-item-" + vid).remove(),
                g_sm_ella.doUpdateDropdownCart(e),
                g_sm_ella.checkBundleProducts();
                var dl=dd.closest("dl");
                dd.remove();
                var len=dl.find("dd").length;
                if(len<=1){
                  dl.prev("h4").remove();
                  dl.remove();
                }
                //this._getSelectedTubeColorList();
              }.bind(this));
              
            }.bind(this));
          }
          g_sm_ella.doUpdateDropdownCart(cart);
          if(fn){
            fn();
          }
      }.bind(this));
    },
    _initBtnAddToCartTube:function(){
      this.$btnAddCart.on("click",function(evt){

        var obj = $(evt.target);
        var disabled=$(obj).attr("aria-disabled");
        
        if(disabled)return;
        if (!this.ajaxEnabled) return;

        evt.preventDefault();
        var slcColor=$("[data-properties-colors]",this.$container).val();
        if(slcColor==""){
          this._showErrorMessage("Pls Select Color.");
          return;
        }
        var vid=$("#ProductSelect-product-template-default").val();
        if(!vid){
          this._showErrorMessage("Goods Sold Out");
          return;
        }
        this.$previouslyFocusedElement = $(':focus');
        var isInvalidQuantity = this.$quantityInput.val() <= 0;
        if (isInvalidQuantity) {
          this._showErrorMessage("Quantity must be 1 or more");
          return;
        }

        if (!isInvalidQuantity && this.ajaxEnabled) {
          // disable the addToCart and dynamic checkout button while
          // request/cart popup is loading and handle loading state
          this._handleButtonLoadingState(true);
          var $data = $("#add-to-cart-form", this.$container);
          //tube
          if(this.pageType=="palette"){
              if(this._exist()){
                  this._uploadFile(function(err){
                      if(err!=""){
                      this._showErrorMessage(err);
                      }
                      else{
                      this._addItemToCart($data);
                      }
                  }.bind(this));
              }
              else{ this._addItemToCart($data);}
          }
          else{ this._addItemToCart($data);}
          return;
        }
        return;
      }.bind(this));
    },
    _showMsg:function(msg,closeSec){
      $("#divSMInfoMsg").show().find("span").first().html(msg);
      var tmid= window.setTimeout(function(){
        $("#divSMInfoMsg").show().hide();
        window.clearTimeout(tmid);
      },closeSec)
    }
  });
  return Palette;
})();
var g_smthemePalette=null;
$(document).ready(function(){
  g_smthemePalette = new theme.Palette($(".sm-cpalette"),this);
  // var isDiyPack=$("#htxDiyPack").val();
  // if(isDiyPack=="true"){
  //   var fnTimeId=0;
  //   var fn=function(){
  //     var label=$(".uploadkit-uploader .uploadkit-label");
  //     console.log(fnTimeId);
  //     if(label.length>0){
  //       if(g_smthemePalette.pageType=="palette"){
  //         //$(".uploadkit-uploader .uploadkit-label").hide();
  //       }
  //       $(".uploadkit-uploader .uploadkit-button").text("Upload logo file");
  //       $(".uploadkit-uploader .uploadkit-attribute-container").on("DOMNodeInserted",
  //         function(){
  //           $(".uploadkit-uploader .uploadkit-button").text("Upload logo file");
  //       });
  //       window.clearTimeout(fnTimeId);
  //     }
  //     else{
  //       window.clearTimeout(fnTimeId);
  //       fnTimeId=window.setTimeout(fn,1000);
  //     }
  //   }
  //   fnTimeId=window.setTimeout(fn,1000);
  // }
});